module.exports = __webpack_public_path__ + "img/default-btn-th.84ea4750.png";